export default {
  methods: {
    volumetricWeight(height, width, length) {
      return (height * width * length) / 5000;
    }
  }
};
